import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { getUserList } from "../../../redux/invoice/action";
import ReactSelect from "react-select";
import { showToast } from "../../Common/Utils/Toaster";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

export default function InvoiceFilter({ modal, setModal, params, setParams }) {
  const dispatch = useDispatch();
  const userList = useSelector((state) => state?.reusableSlice?.userList);

  const [selectedOptions, setSelectedOptions] = useState(() => {
    if (params.user_id) {
      const user = userList?.users?.find(
        (user) => user.id === Number(params.user_id)
      );
      return user
        ? {
            value: user.id,
            label: user.full_name,
          }
        : null;
    }
    return null;
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "start_date" && params.end_date && value > params.end_date) {
      showToast("Start date cannot be greater than End date.", "error");
      return;
    }

    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
      page: 1,
    }));
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    setParams((prevParams) => ({
      ...prevParams,
      user_id: selected?.value || "",
      page: 1,
    }));
  };

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.company_name,
  }));

  const handleApplyFilter = () => {
    setModal(false);
  };

  const handleClearFilters = () => {
    setParams({
      page: 1,
      search_key: "",
      status: "",
      invoice_type: "",
      start_date: "",
      end_date: "",
      user_id: "",
      environment: "",
      testing_account_filter: "hide",
      sort_by: "date_time",
      sort_order: "desc",
    });
    setSelectedOptions(null);
    setModal(false);
  };

  useEffect(() => {
    dispatch(getUserList({
      search_key: "",
      testing_account_filter: params.testing_account_filter || "hide",
    }));
  }, [dispatch, params.testing_account_filter]);

  useEffect(() => {
    if (params.user_id && userList?.users) {
      const user = userList.users.find(
        (user) => user.id === Number(params.user_id)
      );
      if (user) {
        setSelectedOptions({
          value: user.id,
          label: user.company_name,
        });
      }
    }
  }, [userList, params.user_id]);
  return (
    <Modal
      className="filter-modal"
      isOpen={modal}
      toggle={() => setModal((state) => !state)}
      centered
      size="lg"
    >
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Filter Options
      </ModalHeader>

      <ModalBody>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Company</label>
            <ReactSelect
              value={selectedOptions}
              onChange={handleChange}
              options={proOptions}
              placeholder="Select Company"
            />
          </div>

          <div className="col-md-6 form-group">
            <label>Document Type</label>
            <select
              className="form-control"
              name="invoice_type"
              value={params.invoice_type}
              onChange={handleInputChange}
            >
              <option value="">All Document Types</option>
              <option value="0">Simplified</option>
              <option value="1">TAX</option>
              <option value="2">Purchase</option>
              <option value="3">Credit Note</option>
              <option value="4">Debit Note</option>
            </select>
          </div>

          <div className="col-md-6 form-group">
            <label>Start-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="start_date"
              value={params.start_date}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 form-group">
            <label>End-Date</label>
            <input
              type="date"
              className="form-control w-100"
              name="end_date"
              value={params.end_date}
              onChange={handleInputChange}
              min={params.start_date}
            />
          </div>
          <TestingAccountFilter
            className="col-md-6 form-group"
            value={params.testing_account_filter || "hide"}
            onChange={handleInputChange}
          />
          <div className="col-md-6 form-group">
            <label>Environment</label>
            <select
              className="form-control"
              name="environment"
              value={params.environment || ""}
              onChange={handleInputChange}
            >
              <option value="">All Environments</option>
              <option value="live">Live</option>
              <option value="sandbox">Sandbox</option>
            </select>
          </div>
          <div className="col-md-6 form-group">
            <label>Sort By</label>
            <select
              className="form-control"
              name="sort_by"
              value={params.sort_by || "date_time"}
              onChange={handleInputChange}
            >
              <option value="date_time">Document Date</option>
              <option value="user_id">User ID</option>
              <option value="company_name">Company</option>
              <option value="document_number">Document Number</option>
              <option value="counterparty_name">Customer / Supplier</option>
              <option value="invoice_type">Document Type</option>
              <option value="total">Document Total</option>
            </select>
          </div>
          <div className="col-md-6 form-group">
            <label>Sort Order</label>
            <select
              className="form-control"
              name="sort_order"
              value={params.sort_order || "desc"}
              onChange={handleInputChange}
            >
              <option value="desc">Descending</option>
              <option value="asc">Ascending</option>
            </select>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <button className="buttons border-button" onClick={handleClearFilters}>
          <span>Clear Filters</span>
        </button>
        <button
          className="buttons background-button"
          onClick={handleApplyFilter}
        >
          <span>Apply Filter</span>
        </button>
      </ModalFooter>
    </Modal>
  );
}
